import { Builder } from '@builder.io/react';
import { BuilderComponentState } from '@builder.io/react/dist/types/src/components/builder-component.component';
import React, { FC, useEffect, useState } from 'react';

import ArticlesCarousel from '@/components/articles-carousel/articles-carousel';
import { Article } from '@/types/article';
import { BUILDER_MODEL, BuilderReference } from '@/types/builder';
import { getFeaturedArticles } from '@/utils/Article';

import { RoomstayBlogFeaturedArticlesConfig } from './roomstay-blog-featured-articles.builder-component';
import styles from './roomstay-blog-featured-articles.module.scss';

export interface SSProps {
    fixedArticles?: Article[];
    builderState?: BuilderComponentState;
}

export interface BuilderProps {
    backgroundColor?: string;
    articles?: {
        article?: BuilderReference<BUILDER_MODEL.ARTICLE>;
    }[];
}

export interface Props extends BuilderProps, SSProps {}

const RoomstayBlogFeaturedArticles: FC<Props> = (props) => {
    const { articles: articlesProps, builderState } = props;
    const [articles, setArticles] = useState<Article[]>(builderState?.state?.[RoomstayBlogFeaturedArticlesConfig.name].fixedArticles || []);

    const getDataClientSide = async () => {
        const articles = await getFeaturedArticles(articlesProps);
        setArticles(articles);
    };

    useEffect(() => {
        if (Builder.isEditing) {
            getDataClientSide();
        }
    }, [articlesProps]);

    if (!articles || !articles.length) return null;

    return (
        <div className={styles.root}>
            <div className={styles.background}></div>
            <ArticlesCarousel articles={articles} />
        </div>
    );
};

export default RoomstayBlogFeaturedArticles;
